<template>
  <Card class="layout-card recharge-panel-card">
    <div v-if="mode === 'list'" class="list-page">
      <div class="toolbar">
        <div class="toolbar-left">
          <Select v-model="searchForm.audience" class="filter-select" clearable transfer placeholder="请选择人群包">
            <!-- <Option value="">全部人群</Option> -->
            <Option
              v-for="item in audienceOptions"
              :key="item.value"
              :value="item.value"
            >
              {{ item.label }}
            </Option>
          </Select>
          <Select v-model="searchForm.status" class="filter-select" clearable  transfer placeholder="请选择状态">
            <!-- <Option value="">全部状态</Option> -->
            <Option value="1">已启用</Option>
            <Option value="0">未启用</Option>
          </Select>
          <Input
            v-model="searchForm.strategyName"
            class="search-input"
            placeholder="搜索策略名称"
            clearable
          />
          <Button type="primary" @click="getData()">查询</Button>
          <Button @click="handleReset">重置</Button>
        </div>
        <div class="toolbar-right">
          <Button class="third-switch-btn" @click="openGlobalSwitch">
            三方全局开关
          </Button>
          <Button type="success" @click="handleAdd">
            <Icon type="md-add" />
            新增策略
          </Button>
        </div>
      </div>

      <div class="table-wrap">
        <Table
          :columns="columns"
          :data="tableData"
          :loading="loading"
        >
          <template #audience="{ row }">
            <div class="audience-tags">
              <span
                v-for="item in row.audience"
                :key="item"
                class="audience-tag"
              >
                {{ item }}
              </span>
            </div>
          </template>
          <template #iosConfig="{ row }">
            <div class="config-tags">
              <span
                v-for="item in row.iosConfig"
                :key="item.label"
                class="config-tag"
                :class="{ disabled: !item.enabled }"
              >
                {{ item.label }}
              </span>
            </div>
          </template>
          <template #androidConfig="{ row }">
            <div class="config-tags">
              <span
                v-for="item in row.androidConfig"
                :key="item.label"
                class="config-tag"
                :class="{ disabled: !item.enabled }"
              >
                {{ item.label }}
              </span>
            </div>
          </template>
          <template #enabled="{ row, index }">
            <i-switch
              :value="row.enabled"
              :disabled="
                loading ||
                Boolean(statusChangingId) ||
                (Number(row.crowdType) === -1 && Number(row.status) === 1)
              "
              :loading="statusChangingId === row.id"
              :before-change="() => beforeStatusChange(row)"
              @on-change="(value) => handleStatusChange(index, value)"
            />
          </template>
          <template #action="{ row }">
            <div class="action-links">
              <a @click="handleView(row)">查看</a>
              <a @click="handleEdit(row)">编辑</a>
              <a
                v-if="
                  !(Number(row.crowdType) === -1 && Number(row.status) === 1)
                "
                class="danger"
                @click="handleDelete(row)"
              >
                删除
              </a>
            </div>
          </template>
          <Pages slot="footer" :page="page" :func="handlePageChange" />
        </Table>
      </div>

      <Modal
        v-model="showGlobalSwitch"
        title="全局开关"
        width="500"
        @on-cancel="cancelGlobalSwitch"
      >
        <Alert type="warning" show-icon style="margin-bottom: 20px">
          只有全局开关设置为开启时，其他国家的配置才会生效
        </Alert>
        <Form :label-width="100">
          <FormItem label="iOS总开关">
            <RadioGroup v-model="globalForm.iosGlobalSwitch" type="button">
              <Radio
                v-for="item in iosGlobalSwitchOptions"
                :key="item.dictValue"
                :label="Number(item.dictValue)"
              >
                {{ item.dictName }}
              </Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="安卓总开关">
            <RadioGroup v-model="globalForm.androidGlobalSwitch" type="button">
              <Radio
                v-for="item in androidGlobalSwitchOptions"
                :key="item.dictValue"
                :label="Number(item.dictValue)"
              >
                {{ item.dictName }}
              </Radio>
            </RadioGroup>
          </FormItem>
        </Form>
        <div slot="footer">
          <Button @click="cancelGlobalSwitch">取消</Button>
          <Button
            type="primary"
            :loading="globalLoading"
            @click="saveGlobalSwitchData"
          >
            保存修改
          </Button>
        </div>
      </Modal>
    </div>

    <RechargeTemplateEditor
      v-else
      :mode="mode"
      :edit-data="editData"
      @back="handleBack"
      @save="handleSaveConfig"
    />
  </Card>
</template>

<script>
import Pages from '@/components/pages'
import RechargeTemplateEditor from './components/EditConfig.vue'
import {
  addRechargeTemplateConfig,
  changeRechargeTemplateConfigStatus,
  delRechargeTemplateConfig,
  editRechargeTemplateConfig,
  getRechargeTemplateConfigInfo,
  getRechargeTemplateConfigPage,
  getRechargeTemplateEntryOptions
} from '@/api/fee'
import { getCrowdList } from '@/api/crowd'
import { getDictionaryList } from '@/api/dictionary'
import { getGlobalSwitch, saveGlobalSwitch } from '@/api/thirdParty'

const CONFIG_LABELS = [
  { entryId: 0, label: '付费墙', aliases: ['付费墙'], requiresPayItems: true },
  { entryId: 1, label: '钱包页', aliases: ['钱包页', '钱包'], requiresPayItems: true },
  { entryId: 2, label: 'VIP页', aliases: ['VIP页', 'VIP'], requiresPayItems: true },
  { entryId: 4, label: '活动H5', aliases: ['活动H5', '活动'] },
  { entryId: 3, label: '折扣弹窗', aliases: ['折扣弹窗', '折扣'] }
]

export default {
  name: 'FeeRechargeTemplate',
  components: {
    Pages,
    RechargeTemplateEditor
  },
  data() {
    return {
      mode: 'list',
      editData: null,
      loading: false,
      statusChangingId: '',
      showGlobalSwitch: false,
      globalLoading: false,
      globalForm: {
        iosGlobalSwitch: 0,
        androidGlobalSwitch: 0
      },
      globalFormBackup: null,
      entryOptions: [],
      iosGlobalSwitchOptions: [],
      androidGlobalSwitchOptions: [],
      searchForm: {
        audience: '',
        status: '',
        strategyName: ''
      },
      audienceOptions: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      columns: [
        {
          title: '策略名称',
          key: 'strategyName',
          minWidth: 150
        },
        {
          title: '人群包',
          slot: 'audience',
          minWidth: 110
        },
        {
          title: 'IOS 配置',
          slot: 'iosConfig',
          minWidth: 270
        },
        {
          title: 'Android 配置',
          slot: 'androidConfig',
          minWidth: 270
        },
        {
          title: '最后更新',
          key: 'updateTime',
          width: 150
        },
        {
          title: '启用',
          slot: 'enabled',
          width: 90,
          align: 'center'
        },
        {
          title: '操作',
          slot: 'action',
          width: 130
        }
      ],
      tableData: []
    }
  },
  mounted() {
    this.loadEntryOptions()
    this.loadAudienceOptions()
    this.loadGlobalSwitchOptions()
    this.getData()
  },
  methods: {
    getResponseList(response) {
      const data = response && response.data
      if (Array.isArray(data)) return data
      return data && Array.isArray(data.records) ? data.records : []
    },
    async loadEntryOptions() {
      try {
        const { data } = await getRechargeTemplateEntryOptions()
        this.entryOptions = Array.isArray(data) ? data : []
        this.tableData = this.tableData.map((item) => this.normalizeListRow(item))
      } catch (error) {
        this.entryOptions = []
      }
    },
    async loadAudienceOptions() {
      try {
        const { data } = await getCrowdList({ current: 1, size: 100000 })
        const records = data && Array.isArray(data.records) ? data.records : []
        this.audienceOptions = records.map((item) => ({
          label: item.name,
          value: item.id
        }))
      } catch (error) {
        this.audienceOptions = []
      }
    },
    async loadGlobalSwitchOptions() {
      try {
        const [iosGlobalRes, androidGlobalRes] = await Promise.all([
          getDictionaryList({ dictTopic: 'PAY_IOS_GLOBAL_SWITCH_OPTIONS' }),
          getDictionaryList({ dictTopic: 'PAY_ANDROID_GLOBAL_SWITCH_OPTIONS' })
        ])
        this.iosGlobalSwitchOptions = this.getResponseList(iosGlobalRes)
        this.androidGlobalSwitchOptions =
          this.getResponseList(androidGlobalRes)
      } catch (error) {
        this.iosGlobalSwitchOptions = []
        this.androidGlobalSwitchOptions = []
      }
    },
    buildSearchParams() {
      const params = {
        current: this.page.current,
        size: this.page.size
      }
      if (this.searchForm.strategyName) {
        params.name = this.searchForm.strategyName
      }
      // if (this.searchForm.status !== '') {
      //   params.status = Number(this.searchForm.status)
      // }
      params.status = this.searchForm.status
      if (this.searchForm.audience !== '') {
        params.crowdId = this.searchForm.audience
      }
      return params
    },
    async getData(current) {
      if (current) this.page.current = current
      else this.page.current = 1
      this.loading = true
      try {
        const { data } = await getRechargeTemplateConfigPage(
          this.buildSearchParams()
        )
        const records = data && Array.isArray(data.records) ? data.records : []
        this.tableData = records.map((item) => this.normalizeListRow(item))
        this.page.current = data && data.current ? data.current : this.page.current
        this.page.total = data && data.total ? data.total : 0
      } finally {
        this.loading = false
      }
    },
    handleReset() {
      this.searchForm = {
        audience: '',
        status: '',
        strategyName: ''
      }
      this.getData()
    },
    handlePageChange(current) {
      this.getData(current)
    },
    formatDate(date) {
      const pad = (value) => String(value).padStart(2, '0')
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
        date.getDate()
      )} ${pad(date.getHours())}:${pad(date.getMinutes())}`
    },
    formatTime(value) {
      if (!value) return ''
      const date = new Date(value)
      if (Number.isNaN(date.getTime())) return String(value)
      return this.formatDate(date)
    },
    buildLegacyConfigTags(entryPoints) {
      const text = Array.isArray(entryPoints)
        ? entryPoints.join(',')
        : String(entryPoints || '')
      return CONFIG_LABELS.map((item) => ({
        label: item.label,
        enabled: [
          ...item.aliases,
          ...this.entryOptions
            .filter((option) => Number(option.entryId) === item.entryId)
            .map((option) => option.entryName)
        ].some((alias) => alias && text.includes(alias))
      }))
    },
    getRuleByEntryId(rules = [], entryId) {
      return rules.find((item) => Number(item.entryId) === Number(entryId))
    },
    normalizeConfigRules(rules) {
      if (Array.isArray(rules)) return rules
      if (typeof rules !== 'string' || !rules.trim()) return null

      try {
        const data = JSON.parse(rules)
        if (Array.isArray(data)) return data
        return Array.isArray(data.records) ? data.records : null
      } catch (error) {
        return null
      }
    },
    isRuleSwitchOn(rule = {}) {
      let value = rule.status
      if (rule.enabled !== undefined) value = rule.enabled
      if (rule.thirdPay !== undefined) value = rule.thirdPay
      if (rule.switchOn !== undefined) value = rule.switchOn
      return value === true || Number(value) === 1
    },
    isThirdPartyOn(value) {
      if (value === true || Number(value) === 1) return true
      if (typeof value !== 'string') return false

      return ['true', 'on', 'open', '开启'].includes(value.trim().toLowerCase())
    },
    buildEntryPointTags(entryPoints) {
      if (
        !Array.isArray(entryPoints) ||
        !entryPoints.some((item) => item && typeof item === 'object')
      ) {
        return null
      }

      return entryPoints
        .filter((item) => item && typeof item === 'object')
        .map((item) => ({
          label: item.entryName || item.name || item.label || '',
          enabled: this.isThirdPartyOn(item.thirdPartyOn)
        }))
        .filter((item) => item.label)
    },
    hasPayItems(rule = {}) {
      const list =
        rule.payItems ||
        rule.payItemList ||
        rule.payItemDTOList ||
        rule.items ||
        []

      if (Array.isArray(list) && list.length) {
        return list.some((item) => {
          return (
            item &&
            (item.goodsId ||
              item.goodsId === 0 ||
              item.id ||
              item.id === 0 ||
              item.goodsName)
          )
        })
      }

      const count =
        rule.payItemCount ||
        rule.payItemsCount ||
        rule.goodsCount ||
        rule.itemCount
      if (count !== undefined && count !== null) return Number(count) > 0

      const ids = rule.goodsIds || rule.payItemIds
      if (Array.isArray(ids)) return ids.length > 0
      return Boolean(ids)
    },
    hasThirdPayMethods(rule = {}) {
      const list = Array.isArray(rule.payMethods) ? rule.payMethods : []
      const thirdPayMethods = list.filter((item) => {
        return item && item.payMethod !== '' && Number(item.payMethod) !== 0
      })

      if (!thirdPayMethods.length) return false
      return thirdPayMethods.every((item) => {
        return (
          item.provider === 0 ||
          (item.provider !== undefined &&
            item.provider !== null &&
            item.provider !== '')
        )
      })
    },
    hasPushRules(rule = {}) {
      const ids = rule.pushRuleIds || rule.pushRuleIdList
      if (Array.isArray(ids)) return ids.length > 0
      return Boolean(ids)
    },
    buildConfigTags(rules, entryPoints) {
      const entryPointTags = this.buildEntryPointTags(entryPoints)
      if (entryPointTags) return entryPointTags

      const normalizedRules = this.normalizeConfigRules(rules)
      if (!normalizedRules) {
        return this.buildLegacyConfigTags(entryPoints)
      }

      return CONFIG_LABELS.reduce((list, item) => {
        const rule = this.getRuleByEntryId(normalizedRules, item.entryId)

        if (item.requiresPayItems) {
          if (!rule || !this.hasPayItems(rule)) return list
          list.push({
            label: item.label,
            enabled: this.isRuleSwitchOn(rule)
          })
          return list
        }

        list.push({
          label: item.label,
          enabled: rule ? this.isRuleSwitchOn(rule) : false
        })
        return list
      }, [])
    },
    normalizeAudience(row) {
      if (Number(row.crowdType) === -1) return ['不限']
      if (Array.isArray(row.crowdNames) && row.crowdNames.length) {
        return row.crowdNames
      }
      if (Array.isArray(row.crowdIds) && row.crowdIds.length) {
        return row.crowdIds.map((item) => String(item))
      }
      return []
    },
    normalizeListRow(row = {}) {
      return {
        ...row,
        strategyName: row.name || row.strategyName || '',
        audience: this.normalizeAudience(row),
        iosConfig: this.buildConfigTags(row.iosRules, row.iosEntryPoints),
        androidConfig: this.buildConfigTags(
          row.androidRules,
          row.androidEntryPoints
        ),
        updateTime: this.formatTime(row.updateTime),
        enabled: Number(row.status) === 1
      }
    },
    validatePlatformEnableConfig(platformLabel, rules = []) {
      const normalizedRules = this.normalizeConfigRules(rules) || []

      const payItemLabels = CONFIG_LABELS.filter(
        (label) => label.requiresPayItems
      )
      for (const item of payItemLabels) {
        const rule = this.getRuleByEntryId(normalizedRules, item.entryId)
        if (!rule || !this.hasPayItems(rule)) {
          return `${platformLabel}${item.label}至少配置一个付费项`
        }
      }

      for (const item of CONFIG_LABELS) {
        const rule = this.getRuleByEntryId(normalizedRules, item.entryId)
        if (!rule || !this.isRuleSwitchOn(rule)) continue

        if (item.requiresPayItems && !this.hasPayItems(rule)) {
          return `${platformLabel}${item.label}开启三方前需配置付费项`
        }
        if (!this.hasThirdPayMethods(rule)) {
          return `${platformLabel}${item.label}开启三方后需配置支付方式`
        }
        if (Number(item.entryId) === 4 && !this.hasPushRules(rule)) {
          return `${platformLabel}活动H5开启三方后需选择活动`
        }
      }

      return ''
    },
    validateEnableConfig(detail = {}) {
      if (!(detail.name || detail.strategyName || '').trim()) {
        return '请输入策略名称'
      }

      if (
        Number(detail.crowdType) !== -1 &&
        (!Array.isArray(detail.crowdIds) || !detail.crowdIds.length)
      ) {
        return '请选择人群包'
      }

      return (
        this.validatePlatformEnableConfig('iOS', detail.iosRules) ||
        this.validatePlatformEnableConfig('Android', detail.androidRules)
      )
    },
    async beforeStatusChange(row) {
      if (!row || !row.id || this.statusChangingId) {
        return Promise.reject(new Error('status changing'))
      }

      const nextEnabled = !row.enabled
      this.statusChangingId = row.id
      try {
        if (nextEnabled) {
          const detail = await this.loadDetail(row)
          const errorMessage = this.validateEnableConfig(detail)
          if (errorMessage) {
            this.$Message.error(errorMessage)
            return Promise.reject(new Error(errorMessage))
          }
        }

        await changeRechargeTemplateConfigStatus({
          id: row.id,
          status: nextEnabled ? 1 : 0
        })
        this.$Message.success('操作成功')
        return true
      } catch (error) {
        return Promise.reject(error)
      } finally {
        this.statusChangingId = ''
      }
    },
    handleStatusChange(index, value) {
      const row = this.tableData[index]
      if (!row) return
      this.$set(this.tableData[index], 'enabled', value)
      this.$set(this.tableData[index], 'status', value ? 1 : 0)
    },
    handleAdd() {
      this.editData = null
      this.mode = 'add'
    },
    async loadDetail(row) {
      const { data } = await getRechargeTemplateConfigInfo(row.id)
      const detail = data || {}
      return {
        ...row,
        ...detail,
        strategyName: detail.name || row.strategyName,
        audience: this.normalizeAudience(detail)
      }
    },
    async handleView(row) {
      try {
        this.loading = true
        this.editData = await this.loadDetail(row)
        this.mode = 'view'
      } finally {
        this.loading = false
      }
    },
    async handleEdit(row) {
      try {
        this.loading = true
        this.editData = await this.loadDetail(row)
        this.mode = 'edit'
      } finally {
        this.loading = false
      }
    },
    handleBack() {
      this.mode = 'list'
      this.editData = null
      this.getData(this.page.current)
    },
    async handleSaveConfig(payload, done) {
      try {
        if (payload.id) {
          await editRechargeTemplateConfig(payload)
        } else {
          const submitData = { ...payload }
          delete submitData.id
          await addRechargeTemplateConfig(submitData)
        }
        this.$Message.success('保存成功')
        this.mode = 'list'
        this.editData = null
        this.getData(payload.id ? this.page.current : 1)
      } catch (error) {
        console.error('保存充值模板配置失败', error)
      } finally {
        if (done) done()
      }
    },
    handleDelete(row) {
      this.$Modal.confirm({
        title: '删除确认',
        content: `确定删除「${row.strategyName}」吗？`,
        onOk: async () => {
          await delRechargeTemplateConfig(row.id)
          this.$Message.success('删除成功')
          this.getData(this.page.current)
        }
      })
    },
    async openGlobalSwitch() {
      this.showGlobalSwitch = true
      if (
        !this.iosGlobalSwitchOptions.length ||
        !this.androidGlobalSwitchOptions.length
      ) {
        await this.loadGlobalSwitchOptions()
      }
      await this.loadGlobalSwitch()
    },
    async loadGlobalSwitch() {
      try {
        const { data } = await getGlobalSwitch()
        if (data) {
          this.globalForm.iosGlobalSwitch = data.iosGlobalSwitch || 0
          this.globalForm.androidGlobalSwitch = data.androidGlobalSwitch || 0
          this.globalFormBackup = { ...this.globalForm }
        }
      } catch (error) {
        console.error(error)
      }
    },
    cancelGlobalSwitch() {
      this.showGlobalSwitch = false
      if (this.globalFormBackup) {
        this.globalForm = { ...this.globalFormBackup }
      }
    },
    async saveGlobalSwitchData() {
      this.globalLoading = true
      try {
        await saveGlobalSwitch({
          iosGlobalSwitch: this.globalForm.iosGlobalSwitch,
          androidGlobalSwitch: this.globalForm.androidGlobalSwitch
        })
        this.$Message.success('全局开关保存成功')
        this.showGlobalSwitch = false
        this.globalFormBackup = { ...this.globalForm }
      } catch (error) {
        this.$Message.error('保存失败')
      } finally {
        this.globalLoading = false
      }
    }
  }
}
</script>

<style scoped lang="less">
.recharge-panel-card {
  height: 100%;

  /deep/ .ivu-card-body {
    height: 100%;
  }
}

.list-page {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 10px;
  flex-shrink: 0;
  gap: 12px;
}

.toolbar-left,
.toolbar-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.toolbar-left {
  flex: 1;
}

.toolbar-right {
  flex-shrink: 0;
}

.filter-select {
  width: 120px;
}

.search-input {
  width: 180px;
}

.third-switch-btn {
  color: #555;
}

.table-wrap {
  height: 100%;
  overflow: auto;
}

.config-table {
  width: 100%;
  min-width: 1100px;

  /deep/ .ivu-table {
    font-size: 12px;
  }

  /deep/ .ivu-table th {
    height: 34px;
    color: #666;
    font-weight: 400;
    background: #fff;
  }

  /deep/ .ivu-table td {
    height: 40px;
    color: #333;
  }

  /deep/ .ivu-table:before,
  /deep/ .ivu-table:after {
    display: none;
  }

}

.audience-tags,
.config-tags,
.action-links {
  display: flex;
  align-items: center;
}

.audience-tags,
.config-tags {
  flex-wrap: wrap;
  gap: 4px;
}

.audience-tag {
  padding: 1px 6px;
  color: #9254de;
  line-height: 18px;
  background: #f9f0ff;
  border: 1px solid #d3adf7;
  border-radius: 2px;
}

.config-tag {
  padding: 1px 6px;
  color: #1890ff;
  line-height: 18px;
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  border-radius: 2px;
}

.config-tag.disabled {
  color: #999;
  background: #f5f5f5;
  border-color: #ddd;
}

.action-links {
  gap: 5px;

  a {
    color: #2d8cf0;
  }

  .danger {
    color: #ff4d4f;
  }
}
</style>
